// Asegúrate de tener el campo de búsqueda con el id "search-input" y el contenedor de resultados con el id "search-results"
document.getElementById('search-input').addEventListener('input', function() {
    var query = this.value.toLowerCase();
    var resultsContainer = document.getElementById('search-results');

    // Realizamos la solicitud a la API de búsqueda (search.json)
    fetch('/search.json?q=' + query)
        .then(response => response.json())
        .then(data => {
            // Filtramos los productos obtenidos
            var results = data.results.filter(product => {
                return product.title.toLowerCase().includes(query) || 
                       product.description.toLowerCase().includes(query) || 
                       product.tags.toLowerCase().includes(query);
            });

            // Limpiamos el contenedor de resultados
            resultsContainer.innerHTML = '';

            // Mostramos los resultados filtrados
            results.forEach(product => {
                var resultItem = document.createElement('div');
                resultItem.classList.add('search-result-item');
                resultItem.innerHTML = `
                    <a href="${product.url}">
                        <img src="${product.image}" alt="${product.title}" />
                        <h3>${product.title}</h3>
                        <p>${product.description}</p>
                        <span>${product.price}</span>
                    </a>
                `;
                resultsContainer.appendChild(resultItem);
            });

            // Si no hay resultados, mostramos un mensaje
            if (results.length === 0) {
                resultsContainer.innerHTML = '<p>No se encontraron resultados para tu búsqueda.</p>';
            }
        })
        .catch(error => console.error('Error fetching search results:', error));
});
